// extracted by mini-css-extract-plugin
export var contact_area = "contact-area-module--contact_area--139sV";
export var contact_area__text = "contact-area-module--contact_area__text--2Hu1p";
export var contact_area__button_wrap = "contact-area-module--contact_area__button_wrap--2F_Kw";
export var contact_area_button = "contact-area-module--contact_area_button--3Jlx8";
export var button_02 = "contact-area-module--button_02--1jiUd";